export const TagsList = {
  props: {
    target: String
  },
  data() {
    return {
      listTags: [],
      searchBox: '',
      searchInput: '',
    }
  },

  mounted() {
    this.fillListTags()
    this.initEventListener()
  },

  beforeDestroy() {
    this.deleteEventListener()
  },

  methods: {

    onChange(event) {
      const id = event.target.id
      const label = event.target.labels[0]?.innerText || id
      const isChecked = event.target.checked

      if (isChecked) {
        if (!this.listTags.some(tag => tag.id === id)) {
          this.listTags.push({
            id,
            label,
          })
        }
      } else {
        this.listTags = this.listTags.filter(tag => tag.id !== id)
      }
    },

    updateSearchTag() {
      const id = 'search-box'
      const tagIndex = this.listTags.find(tag => tag.id === this.searchInput.id)

      if (this.searchInput) {
        if (tagIndex) {
          this.listTags[tagIndex].label = this.searchInput
        } else {
          this.listTags.push({
            id,
            label: this.searchInput,
          })
        }
      } else if (!this.searchInput && tagIndex) {
          this.listTags.splice(tagIndex, 1)
      }
    },

    fillListTags() {
      for (const tagItem of jQuery('.js-filter-blog-select-products input, .js-filter-blog-select-mutuals input, .js-filter-blog-select-subject input')) {
        const isChecked = tagItem.checked
        const label = tagItem.labels[0]?.innerText || tagItem.id
        if (tagItem.id && label && isChecked) {
          this.listTags.push({
            id: tagItem.id,
            label,
          })
        }
      }
    },

    initEventListener() {
      for (const tagItem of jQuery('.js-filter-blog-select-products input, .js-filter-blog-select-mutuals input, .js-filter-blog-select-subject input')) {
        tagItem.addEventListener('change', this.onChange)
      }

      this.searchBox = jQuery('.filter-blog__search-field input')
      if (this.searchBox.length >= 1) {
        this.searchInput = this.searchBox.get(0).value
        this.searchBox.on('keyup', this.updateSearchTag())
      }
    },

    deleteEventListener() {
      for (const tagItem of jQuery('.js-filter-blog-select-products input, .js-filter-blog-select-mutuals input, .js-filter-blog-select-subject input')) {
        tagItem.removeEventListener('change', this.onChange)
      }

      if (this.searchBox && this.searchBox.length) {
        this.searchBox.off('keyup', this.updateSearchTag)
      }
    },

    removeTag(tag) {
      this.listTags = this.listTags.filter(target => target.id !== tag.id)
      const checkbox = document.getElementById(tag.id)

      if (checkbox) {
        checkbox.checked = false
      }
      if (this.searchInput === tag.label) {
        this.searchInput = ''
        jQuery('.filter-blog__search-field input').val('')
        jQuery('.filter-blog__search').removeClass('extended')
      }
    },

    iconPath(iconName) {
      return `/themes/custom/promutuel/dist/icons.svg#${iconName}`
    },

  },

  template: `
    <div class="tag-list">
      <tags-list-item v-for="item in listTags"
        :item="item"
        :key="item.id"
        :removeTag="removeTag"
        :iconPath="iconPath"></tags-list-item>
    </div>
  `
}